export default __webpack_public_path__ + "static/media/wheelbase.f9ad522c.png";